import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Utils from '../../../custom/utils';
import {API} from "../../../../config";
import DepositProof from "./depositProof";

const moment = require('moment');

const investorInbound = API.service('inbound-transfers');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class InvestorDeposits extends Component {
    state={
        deposits:[]
    };

    getDeposits = () => {
        const app = this;
        investorInbound.find({query:{_account:this.props.investor._account}}).then(s=>{
            app.setState({
                deposits:s.data
            })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.currency !== this.props.currency || prevProps.investor._id !== this.props.investor._id) {
            this.getDeposits()
        }
    }

    componentDidMount() {
        this.getDeposits()
    }

    render() {
        const {classes} = this.props;
        let currency = Utils.getCurrency(this.props.currency.toUpperCase());

        return (
            <React.Fragment>
                <table className={'w-full'}>
                    <tr className={classes.tableHead}>
                        <td>Date</td>
                        <td className={'text-center pl-2'}>Status</td>
                        <td className={'text-center pl-2'}>Type</td>
                        <td className={'text-center pl-2'}>Amount (Fee)</td>
                        <td className={'text-center pl-2'}>Doc</td>
                    </tr>
                    {this.state.deposits.map((v,i)=>{
                        let amnt = v._amount_expected || v._amount;
                        let states = Utils.returnDepositState(v._status)
                        return (
                            <tr className={classes.tableRow}>
                                <td>{moment(v._timestamp).format('L')}</td>
                                <td className={'text-center pl-2'}><div className={'deposit-label ' + states[0]}>{states[1]}</div></td>
                                <td className={'text-center pl-2'}>{v._fund_type}</td>
                                <td className={'text-right pl-2'}>{currency.currency_symbol}{Utils.addThousandCommas(amnt, '0,0.00')} ({Utils.addThousandCommas(v._fees_paid, '0,0.00')})</td>
                                <td className={'text-center pl-2'}>
                                    <div className={classes.bankDetails}>
                                        <DepositProof depId={v._id} investor={this.props.investor} />
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </table>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(InvestorDeposits)));
